import TruckerListDesktop from './TruckerListDesktop';

export default TruckerListDesktop;
